module.exports = __webpack_public_path__ + "static/img/operateHuhui.0e12731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateHuhui.png
// module id = kySJ
// module chunks = 1